// apps/admin-ui/src/components/WidgetStatusBadge.tsx
// Status badge component for dashboard widgets
// ALL RIGHTS RESERVED

import '../styles/widget-badges.css';

export interface WidgetStatusBadgeProps {
  refreshInterval: number;  // seconds
  isMock: boolean;          // true if endpoint is stubbed
  error: Error | null;      // fetch error
}

/**
 * Format refresh interval for display
 */
function formatInterval(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  return `${Math.floor(seconds / 60)}m`;
}

/**
 * Widget status badge component
 * 
 * Displays one of three states:
 * - ✗ (error) - fetch failed
 * - ◇ (mock) - data is stubbed/demo
 * - ↻ Ns (refresh) - auto-refresh interval
 */
export function WidgetStatusBadge({ refreshInterval, isMock, error }: WidgetStatusBadgeProps) {
  if (error) {
    return (
      <span className="widget-badge widget-badge--error" title={error.message}>
        ✗
      </span>
    );
  }

  if (isMock) {
    return (
      <span className="widget-badge widget-badge--mock" title="Mock data (endpoint not ready)">
        ◇
      </span>
    );
  }

  return (
    <span className="widget-badge widget-badge--refresh" title={`Refreshes every ${formatInterval(refreshInterval)}`}>
      ↻ {formatInterval(refreshInterval)}
    </span>
  );
}

export default WidgetStatusBadge;
